// src/components/Dashboard/charts/OrdersStatusPie.js
// Pie chart para mostrar distribución de estados de las órdenes.

import React from 'react';
import PropTypes from 'prop-types';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Box, Typography } from '@mui/material';

const COLORS = ['#4e73df', '#1cc88a', '#f6c23e', '#e74a3b', '#858796'];

export default function OrdersStatusPie({ statusCounts = {} }) {
  const data = Object.entries(statusCounts).map(([name, value]) => ({ name, value }));

  return (
    <Box sx={{ width: '100%', height: 300 }}>
      <Typography variant="subtitle1" gutterBottom>
        Distribución de estados de órdenes
      </Typography>
      {data.length === 0 ? (
        <Typography variant="body2">Sin datos disponibles.</Typography>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(v) => `${v} órdenes`} />
            <Legend verticalAlign="bottom" height={36} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
}

OrdersStatusPie.propTypes = {
  statusCounts: PropTypes.objectOf(PropTypes.number),
};
